import { useAuth } from "../../context/AuthContext";
import { ArrowRight, Play } from "lucide-react";
import { Link } from "react-router-dom";

// Trial concept removed. This banner now only renders the demo-mode strip.
export const TrialBanner = () => {
  const { user } = useAuth();

  if (user?.plan_type === "demo") {
    return (
      <div
        data-testid="demo-mode-banner"
        className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white px-4 py-2.5 flex items-center justify-between text-sm border-b border-orange-500/20"
      >
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 bg-orange-500/20 rounded-md flex items-center justify-center">
            <Play className="w-3 h-3 text-orange-500" />
          </div>
          <span>
            <strong className="text-orange-400">Live Demo</strong>
            <span className="text-slate-400 ml-2">You&apos;re exploring a pre-populated sandbox. Ready to start your own?</span>
          </span>
        </div>
        <Link to="/request-demo">
          <button
            data-testid="demo-signup-btn"
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-xs px-5 py-1.5 rounded-full transition-all flex items-center gap-1.5 shadow-[0_0_12px_rgba(249,115,22,0.2)]"
          >
            Request Enquiry &amp; Demo
            <ArrowRight className="w-3 h-3" />
          </button>
        </Link>
      </div>
    );
  }

  return null;
};
